{
    "Addusertitle": "Toepassingsgebruikersaccount toevoegen",
    "Modifyusertitle": "Gebruikersaccount van toepassing wijzigen",
    "PermissionsTitle": "Rechten",
    "ExtensionTitle": "Extensie\/eindpunt",
    "ReportingTitle": "Rapportage",
    "AdministratorTitle": "Beheerder",
    "RoleTitle": "Rol",
    "SettingsTitle": "Aangepaste instellingen",
    "ValidationWarning": "Corrigeer fouten voordat u klaar bent",
    "ServerErrorTitle": "Bevestig dat alles correct is getypt en ga dan verder met het importeren van het voltooide bestand hier (Eventuele fouten met het bestand worden opgemerkt tijdens de configuratie):",
    "MonthlyBillingWarning": "WAARSCHUWING: beïnvloedt maandelijkse facturering",
    "UnknownOrDeleted": "of hier slepen en neerzetten.",
    "AddUserLanguage_ButtonHelpLabel": "Helpen?",
    "AddUserLanguage_ButtonSubmitLabel": "Opslaan",
    "AddUserLanguage_ButtonCancelLabel": "Annuleren",
    "AddUserLanguage_PromptMessage": "Weet u zeker dat u dit venster wilt sluiten? Alle gewijzigde configuraties gaan verloren wanneer ze worden gesloten.",
    "AddUserLanguage_PromptConfirm": "Ja",
    "AddUserLanguage_PromptCancel": "Annuleren",
    "AddUserLanguage_DetailsTitle": "CME-details",
    "NAME": "AddUserLanguage",
    "APIKeys_Title": "API-sleutels"
}